import { ref } from 'vue';

const defaults = {
  dismissAfter: 5000,
  type: '',
  onAction: null,
  onDismiss: null,
};

const items = ref([]);
let notificationId = 0;

const addNotification = (item) => {
  notificationId += 1;
  const id = notificationId;
  items.value.push({ ...defaults, ...item, id });
  return id;
};

const removeNotification = (id) => {
  items.value = items.value.filter((item) => item.id !== id);
};

export default function useNotificationsState() {
  return {
    items,
    addNotification,
    removeNotification,
  };
}
